import React, { Component, PropTypes } from 'react';

import './Snackbar.css';

export default class Snackbar extends Component {
    static propTypes = {
        message: PropTypes.string,
        callback: PropTypes.func,
        actionText: PropTypes.string,
        onHide: PropTypes.func,
    }

    constructor(props) {
        super(props);

        this.state = {
            visible: true,
        };

        this.handleActionClick = this.handleActionClick.bind(this);
        this.hide = this.hide.bind(this);
    }

    componentDidMount() {
        if (this.props.message)
            this.startTimeout();
    }

    componentWillReceiveProps(nextProps) {
        // For now we will just check to see if the message has changed.
        // Need a better way of determining if this is a new message instance.
        if (nextProps.message && this.props.message !== nextProps.message) {
            this.setState({
                visible: true,
            });
            this.restartTimeout();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
        if (this.props.onHide)
            this.props.onHide();
    }

    handleActionClick() {
        this.props.callback();
    }

    startTimeout() {
        // TODO: change to 4 when we do the animations
        this.timeout = setTimeout(this.hide, 6 * 1000);
    }

    restartTimeout() {
        clearTimeout(this.timeout);
        this.startTimeout();
    }

    hide() {
        // We don't want to hide if there is a button
        if (!this.props.callback) {
            this.setState(
                { visible: false },
                () => {
                    if (this.props.onHide)
                        this.props.onHide();
                }
            );
        }
    }

    render() {
        const {message, callback, actionText } = this.props;

        // If we have no message we should have no snackbar
        if (!message)
            return null;

        const display = this.state.visible ? `block` : `none`;

        const buttonJsx = callback ?
            <button onClick={this.handleActionClick}>{actionText}</button> : null;

        return (
            <div className="snackbar" style={{ display }}>
                <p className="message">{message}</p>
                {buttonJsx}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/Snackbar.jsx